import type { WidgetSpec } from '@hero/schema';
import type { ChatBubble } from './types';
import { isBubbleSkippedWidgetType, normalizeWidgetSpec } from '@hero/agent';

/** Coerce an SSE / API widget payload into a typed {@link WidgetSpec}. */
export const coerceWidgetSpec = (raw: unknown): WidgetSpec | null => normalizeWidgetSpec(raw);

/** Extract assistant prose + widget specs from committed message blocks. */
export const bubbleFromBlocks = (
  blocks: unknown[],
): Pick<ChatBubble, 'text' | 'widgets'> => {
  const textParts: string[] = [];
  const widgets: WidgetSpec[] = [];

  for (const block of blocks) {
    if (typeof block !== 'object' || block === null || !('kind' in block)) continue;
    const kind = (block as { kind?: string }).kind;
    if (kind === 'text' && 'text' in block && typeof (block as { text?: unknown }).text === 'string') {
      textParts.push((block as { text: string }).text);
    }
    if (kind === 'widget' && 'widget' in block) {
      const spec = coerceWidgetSpec((block as { widget: unknown }).widget);
      if (spec && !isBubbleSkippedWidgetType(spec.type)) {
        widgets.push(spec);
      }
    }
  }

  return {
    text: textParts.join('\n'),
    widgets,
  };
};
